import {provideHttpClient, withInterceptors} from '@angular/common/http'
import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection
} from '@angular/core'
import {MAT_CARD_CONFIG} from '@angular/material/card'
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field'
import {
  provideRouter,
  withHashLocation,
  withInMemoryScrolling
} from '@angular/router'
import {
  authInterceptor,
  ConfigService,
  IConfig, responseInterceptor,
  SPB_LOGIN_SETTINGS,
  SPS_CONFIG
} from '@sparbanken-syd/sparbanken-syd-bankid'
import {environment} from '../environments/environment'
import {routes} from './app.routes'

import {ADMIN_HOME_PATH, ADMIN_ROLE_NAME} from './application/types'

const configServiceConfig: IConfig = {
  authServiceUrl: environment.authServiceUrl,
  domain: environment.domain,
  adminRoles: [ADMIN_ROLE_NAME]
}

export const appConfig: ApplicationConfig = {
  providers: [
    {provide: SPS_CONFIG, useValue: configServiceConfig},
    {
      provide: SPB_LOGIN_SETTINGS, useValue: {
        text: 'För att komma igång behöver du först logga in med ditt BankID',
        buttonText: 'Logga in med BankID',
        route:['/', ADMIN_HOME_PATH],
      }
    },
    provideAppInitializer(() => inject(ConfigService).bootstrap()),
    {provide: MAT_CARD_CONFIG, useValue: {appearance: 'outlined'}},
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {
        subscriptSizing: 'dynamic',
        floatLabel: 'always',
        appearance: 'outline'
      }
    },
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes, withHashLocation(), withInMemoryScrolling({anchorScrolling: 'enabled'})),
    provideHttpClient(
      withInterceptors([
        authInterceptor,
        responseInterceptor
      ])
    )
  ]
}